// @ts-nocheck
export const BASE_URL =
  window?._env_ !== null && window?._env_?.REACT_APP_API_BASE_URL !== undefined
    ? window?._env_?.REACT_APP_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL

const baseURL = BASE_URL || process.env.REACT_APP_API_BASE_URL
export default baseURL
